import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

const TrainingListing = () => {
  const [activeTraining, setActiveTraining] = useState(null);

  const trainingPrograms = [
    {
      id: 1,
      title: "Drivers' Training",
      description: "Specialized training for palliative care transport drivers, focusing on patient comfort, emergency protocols, and safe transportation of medical equipment.",
      detailedDescription: "This comprehensive program covers safe patient transfer techniques, vehicle sanitization protocols, emergency medical response, and compassionate communication with patients and families during transport.",
      icon: "🚗",
      duration: "20 hours",
      audience: "Transport staff, volunteer drivers",
      features: ["Patient transfer safety", "Emergency protocols", "Vehicle sanitization", "Compassionate communication"]
    },
    {
      id: 2,
      title: "Volunteers Training",
      description: "Essential training for palliative care volunteers covering patient interaction, emotional support, and clinic procedures.",
      detailedDescription: "Volunteers learn essential skills for providing emotional support, understanding palliative care principles, maintaining patient dignity, and working within our clinic's guidelines and procedures.",
      icon: "⛑️",
      duration: "30 hours",
      audience: "New volunteers, community supporters",
      features: ["Emotional support techniques", "Patient dignity", "Clinic procedures", "Boundary setting"]
    },
    {
      id: 3,
      title: "Communication Training",
      description: "Develop compassionate communication skills for discussing sensitive topics with patients and families.",
      detailedDescription: "This training focuses on empathetic communication, breaking bad news, active listening, and supporting families through difficult conversations in palliative care settings.",
      icon: "💬",
      duration: "16 hours",
      audience: "All staff and volunteers",
      features: ["Empathetic communication", "Breaking bad news", "Active listening", "Family support"]
    },
    {
      id: 4,
      title: "Geriatric Care Training",
      description: "Specialized training in elderly patient care, focusing on comfort, dignity, and symptom management.",
      detailedDescription: "Comprehensive training in geriatric palliative care including pain management, mobility assistance, cognitive support, and end-of-life care for elderly patients.",
      icon: "👵",
      duration: "40 hours",
      audience: "Caregivers, nurses, support staff",
      features: ["Pain management", "Mobility assistance", "Cognitive support", "End-of-life care"]
    },
    {
      id: 5,
      title: "Refreshment Training",
      description: "Regular updates and skill refreshers for all palliative care team members.",
      detailedDescription: "Ongoing training sessions to keep staff updated with latest palliative care practices, protocol changes, and skill reinforcement for continuous quality improvement.",
      icon: "🔄",
      duration: "8 hours quarterly",
      audience: "All team members",
      features: ["Latest practices", "Protocol updates", "Skill reinforcement", "Quality improvement"]
    },
    {
      id: 6,
      title: "Volunteers' Training of Trainers (ToT)",
      description: "Advanced training for experienced volunteers to become mentors and trainers for new team members.",
      detailedDescription: "This advanced program equips experienced volunteers with mentoring skills, training methodologies, and leadership capabilities to support and guide new volunteers in our palliative care mission.",
      icon: "🌟",
      duration: "24 hours",
      audience: "Senior volunteers, team leaders",
      features: ["Mentoring skills", "Training methodologies", "Leadership development", "Peer support"]
    }
  ];

  const toggleDetails = (id) => {
    setActiveTraining(activeTraining === id ? null : id);
  };

  return (
    <div className="palliative-care-training">
      {/* Hero Section */}
      {/* <section className="hero-section bg-light py-5">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-8 mx-auto text-center">
              <h1 className="display-4 text-primary mb-3">
                Compassionate Care Training Programs
              </h1>
              <p className="lead text-muted mb-4">
                Specialized training programs designed to enhance the quality of palliative care 
                through skilled, compassionate service and professional development.
              </p>
              <div className="alert alert-info" role="alert">
                <strong>Note:</strong> All training programs include palliative care principles and compassionate service components.
              </div>
            </div>
          </div>
        </div>
      </section> */}

      {/* Training Programs Section */}
      <section className="training-programs py-5">
        <div className="container">
          {/* <div className="row">
            <div className="col-12 text-center mb-5">
              <h2 className="text-primary">Our Training Programs</h2>
              <p className="text-muted">Choose from our comprehensive training offerings</p>
            </div>
          </div> */}

          <div className="row">
            {trainingPrograms.map((training) => (
              <div key={training.id} className="col-lg-6 mb-4">
                <div className={`card training-card h-100 border-0 shadow-sm ${activeTraining === training.id ? 'active' : ''}`}>
                  <div className="card-body p-4">
                    <div className="d-flex align-items-start mb-3">
                      <div className="training-icon me-4" style={{ fontSize: '2.5rem' }}>
                        {training.icon}
                      </div>
                      <div className="flex-grow-1">
                        <h4 className="card-title text-primary mb-2">{training.title}</h4>
                        <p className="card-text text-muted mb-3">{training.description}</p>
                        
                        <div className="training-meta mb-3">
                          <small className="text-muted me-3">
                            <strong>Duration:</strong> {training.duration}
                          </small>
                          <small className="text-muted">
                            <strong>For:</strong> {training.audience}
                          </small>
                        </div>

                        {activeTraining === training.id && (
                          <div className="training-details mt-3">
                            <p className="text-dark mb-3">{training.detailedDescription}</p>
                            <div className="features-list">
                              <h6 className="text-primary">Key Topics:</h6>
                              <ul className="list-unstyled">
                                {training.features.map((feature, index) => (
                                  <li key={index} className="mb-1">
                                    <small>✓ {feature}</small>
                                  </li>
                                ))}
                              </ul>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="text-end">
                      <button 
                        className={`btn ${activeTraining === training.id ? 'btn-outline-primary' : 'btn-primary'}`}
                        onClick={() => toggleDetails(training.id)}
                      >
                        {activeTraining === training.id ? 'Show Less' : 'Learn More'}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Call to Action Section */}
      {/* <section className="cta-section bg-primary text-white py-5">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 mx-auto text-center">
              <h3 className="mb-3">Ready to Make a Difference?</h3>
              <p className="mb-4">
                Join our compassionate care team and receive the training you need to provide 
                exceptional palliative care services to our patients and their families.
              </p>
              <div className="d-flex justify-content-center gap-3 flex-wrap">
                <button className="btn btn-light btn-lg">Enroll in Training</button>
                <button className="btn btn-outline-light btn-lg">Contact Coordinator</button>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      {/* Additional Info Section */}
      <section className="info-section py-5">
        <div className="container">
          <div className="row">
            <div className="col-lg-4 mb-4">
              <div className="text-center">
                <div className="info-icon mb-3" style={{ fontSize: '3rem' }}>📋</div>
                <h5>Certification</h5>
                <p className="text-muted">
                  All programs include certification upon successful completion
                </p>
              </div>
            </div>
            <div className="col-lg-4 mb-4">
              <div className="text-center">
                <div className="info-icon mb-3" style={{ fontSize: '3rem' }}>👥</div>
                <h5>Expert Instructors</h5>
                <p className="text-muted">
                  Learn from experienced palliative care professionals
                </p>
              </div>
            </div>
            <div className="col-lg-4 mb-4">
              <div className="text-center">
                <div className="info-icon mb-3" style={{ fontSize: '3rem' }}>🕒</div>
                <h5>Flexible Scheduling</h5>
                <p className="text-muted">
                  Training sessions available at various times to accommodate schedules
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <style jsx>{`
        .training-card {
          transition: all 0.3s ease;
          border-left: 4px solid #007bff !important;
        }
        
        .training-card:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 15px rgba(0,0,0,0.1) !important;
        }
        
        .training-card.active {
          border-left: 4px solid #28a745 !important;
        }
        
        .hero-section {
          background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
        }
        
        .cta-section {
          background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);
        }
        
        .features-list ul li {
          padding-left: 1.5rem;
          position: relative;
        }
        
        .features-list ul li:before {
          content: "✓";
          position: absolute;
          left: 0;
          color: #28a745;
          font-weight: bold;
        }
      `}</style>
    </div>
  );
};

export default TrainingListing;